import 'dayjs/locale/zh-cn';
import { downLoadByUrl, downLoadPPTByUrl, exportFile } from '@/api/commApi/upload';
import { isCarousel, isElevatorOutside, isElevatorType, isHallType, isProjectionType } from '@/utils/mtype';
import apiUrl from "./devApi";
import dayjs from 'dayjs';
import fileDownload from 'js-file-download';
import formReg from "./formReg";
import { Loading } from 'element-ui';
import { param2Obj } from "./index";
import { WHITE_TIP } from "./constant";

dayjs.locale('zh-cn');

let baseURL = process.env;
if(process.env.NODE_ENV == "development") {
    baseURL = Object.assign({}, process.env, apiUrl);
}
export default {
    install(Vue) {
        Vue.prototype.$whiteTip = WHITE_TIP;

        Vue.prototype.$dayjs = dayjs;

        Vue.prototype.$formatMoney = (value, target, key) => {
            value = value.replace(/[^\d.]/g, '');// 清除"数字"和"."以外的字符
            value = value.replace(/^\./g, '');// 验证第一个字符是数字而不是字符
            value = value.replace(/\.{2,}/g, '.');// 只保留第一个.清除多余的
            value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
            value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');// 只能输入两个小数
            Vue.set(target, key, value);
        };
        Vue.prototype.$toBack = (page) => {
            if(page.$route.query.is_blank) {
                page.$router.replace({ path: page.$parentRoute(page.$route) });
            }else {
                page.$router.go(-1);
            }
        };
        Vue.prototype.$parentRoute = (route) => {
            const matched = route.matched.filter(item => item.meta && item.meta.title);
            const routes = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
            let parentRoute = {};
            if(routes.length > 0) {
                parentRoute = routes[routes.length - 1].parent;
            }
            return parentRoute.redirect || parentRoute.path;
        };
        Vue.prototype.$inputFormat = (e) => {
            let value = e.replace(/[^\-\d]/g, ""); // 只能输入-和数字
            value = value.replace(/\-{2,}/g, "-"); // -只能保留一个
            value = value.replace(/(\d)\-/g, "$1"); // 数字后面不能接-，不能出现类似-11-2,12-，11-23
            value = value.replace(/-(0+)/g, "0"); // 不能出现-0,-001,-0001类似
            value = value.replace(/^0+(\d)/, "$1"); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
            return value;
        };
        Vue.prototype.$isElevatorType = isElevatorType;
        Vue.prototype.$isProjectionType = isProjectionType;
        Vue.prototype.$isHallType = isHallType;
        Vue.prototype.$isCarousel = isCarousel;
        Vue.prototype.$isElevatorOutside = isElevatorOutside;
        Vue.prototype.$push = function(path, blank) {
            if(blank) {
                let url;
                if(typeof path == 'object' && path.path) {
                    url = path.path;
                }else if(typeof path == 'string') {
                    url = path;
                }
                const routeUrl = this.$router.resolve({ path: url, query: { is_blank: true }});
                window.open(routeUrl.href, "_blank");
            }else {
                this.$router.push(path);
            }
        };
        Vue.prototype.$open = function(path, type) {
            let tempURL = baseURL.VUE_APP_URL_FW;
            switch (type) {
                case 'zyz': tempURL = baseURL.VUE_APP_URL_ZYZ; break;
            }
            if(path) {
                if(formReg.url(path)) {
                    window.open(path);
                }else {
                    if(path.indexOf('?') == -1) {
                        path += '?is_blank=true';
                    }else {
                        path += '&is_blank=true';
                    }
                    window.open(tempURL + path);
                }
            }else {
                window.open(tempURL);
            }
        };
        Vue.prototype.$dsLoading = function(options) {
            if(typeof options == 'string') {
                options = {
                    text: options
                };
            }
            const opts = Object.assign({
                lock: true,
                text: '拼命加载中...',
                background: 'rgba(0, 0, 0, 0.7)'
            }, options);
            return this.$loading(opts);
        };

        Vue.prototype.$downLoadFile = function(fileUrl, fileName = '', downloadType = 'yun') {
            if(fileUrl) {
                if(formReg.url(fileUrl)) {
                    window.location.href = fileUrl;
                    return false;
                }

                const url = downloadType == 'yun' ? baseURL.VUE_APP_API_YUN : baseURL.VUE_APP_API_FILE;
                if(downloadType == 'file' && process.env.VUE_APP_ENV == 'production') {
                    window.open(url + fileUrl);
                }else {
                    if(!fileName) {
                        fileName = fileUrl.slice(fileUrl.lastIndexOf('/') + 1);
                    }
                    fileName = encodeURIComponent(fileName);
                    const href = url + 'download?fileName=' + fileName + '&fileUrl=' + fileUrl + '&token=' + this.$store.getters.token;
                    window.open(href);
                }
                return false;
            }else {
                this.$message.error("下载连接为空！");
            }
        };

        /**
         * 通过接口返回地址路径进行下载方法
         * fileUrl: 接口路径
         */
        Vue.prototype.$downLoadByUrl = function(fileUrl, param, downloadType = 'file') {
            if(fileUrl) {
                const loadingInstance = Loading.service({
                    lock: true,
                    text: '正在努力导出，请耐心等待...',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                return downLoadByUrl(fileUrl, param).then(res => {
                    if(res.success && res.data) {
                        this.$downLoadFile(res.data, null, downloadType);
                        loadingInstance.close();
                    }
                }).catch(err => {
                    console.log(err);
                    loadingInstance.close();
                });
            }else {
                this.$message.error("下载连接为空！");
                return false;
            }
        };

        Vue.prototype.$downLoadPPT = function(fileUrl, fileName = '', downloadType = 'file') {
            if(fileUrl) {
                if(formReg.url(fileUrl)) {
                    window.location.href = fileUrl;
                    return false;
                }

                const url = downloadType == 'yun' ? baseURL.VUE_APP_API_YUN : baseURL.VUE_APP_API_FILE;
                if(downloadType == 'file') {
                    window.location.href = url + fileUrl;
                }else {
                    if(!fileName) {
                        fileName = fileUrl.slice(fileUrl.lastIndexOf('/') + 1);
                    }
                    fileName = encodeURIComponent(fileName);
                    window.location.href = url + 'download?fileName=' + fileName + '&fileUrl=' + fileUrl + '&token=' + this.$store.getters.token;
                }
                return false;
            }else {
                this.$message.error("下载连接为空！");
            }
        };

        Vue.prototype.$downLoadPPTByUrl = function(fileUrl, param, downloadType = 'file') {
            if(fileUrl) {
                const loadingInstance = Loading.service({
                    lock: true,
                    text: '正在努力导出，请耐心等待...',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                return downLoadPPTByUrl(fileUrl, param).then(res => {
                    if(res.success && res.data) {
                        this.$downLoadPPT(res.data, null, downloadType);
                        loadingInstance.close();
                    }
                }).catch(err => {
                    console.log(err);
                    loadingInstance.close();
                });
            }else {
                this.$message.error("下载连接为空！");
                return false;
            }
        };

        // Vue.prototype.$downLoadYUNByUrl = function(fileUrl, param, downloadType = 'file') {
        //     if(fileUrl) {
        //         const loadingInstance = Loading.service({
        //             lock: true,
        //             text: '正在努力导出，请耐心等待...',
        //             background: 'rgba(0, 0, 0, 0.7)'
        //         });
        //         return downLoadYUNByUrl(fileUrl, param).then(res => {
        //             if(res.success && res.data) {
        //                 this.$downLoadPPT(res.data, null, downloadType);
        //                 loadingInstance.close();
        //             }
        //         }).catch(err => {
        //             console.log(err);
        //             loadingInstance.close();
        //         });
        //     }else {
        //         this.$message.error("下载连接为空！");
        //         return false;
        //     }
        // };

        /**
         * 导出功能
         * url: 请求路径 eg:'/desingExcel/excelRemoveTask'
         * paramsStr: 参数字符串 eg:'taskId=12'
         * msg: 提示语，如果为空就不弹出确认框 */
        Vue.prototype.$exportFile = function(url, paramsStr, msg = "您确认要导出数据吗？") {
            return new Promise((resolve, reject) => {
                if(url) {
                    const fn = () => {
                        const loadingInstance = Loading.service({
                            lock: true,
                            text: '拼命导出中...',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        // const getUrl = baseURL.BASE_API + url + '?' + paramsStr;
                        if(typeof paramsStr == "string") {
                            paramsStr = param2Obj('test?' + paramsStr);
                        }
                        exportFile(url, paramsStr).then(res => {
                            if(res.headers['content-disposition']) {
                                const fileNameArr = res.headers['content-disposition'].match(/filename=(\S*)/);
                                let fileName = fileNameArr[1];
                                fileName = decodeURI(fileName);
                                fileDownload(res.data, fileName);
                            }else {
                                const errorRes = JSON.parse(decodeURI(String.fromCharCode.apply(null, new Uint8Array(res.data)))); // 转化成json对象
                                const decodedString = decodeURIComponent(escape((errorRes.msg)));
                                if(decodedString.indexOf("服务忙") != -1) {
                                    this.$message.error(decodedString);
                                }else {
                                    this.$message.warning(decodedString);
                                }
                            }
                            loadingInstance.close();
                            resolve();
                        }).catch(error => {
                            loadingInstance.close();
                            console.log(error);
                            reject();
                        });
                    };

                    if(msg) {
                        this.$confirm(msg, "提示", {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                            center: true
                        }).then(() => {
                            fn();
                        }).catch(() => {});
                    }else {
                        fn();
                    }
                }else {
                    this.$message.error("导出连接为空！");
                    reject();
                }
            });
        };

        Vue.prototype.$importFile = function(options) {
            return new Promise((resolve, reject) => {
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = options.accept || '.xlsx,.xls';
                input.style.display = 'none';

                // 监听文件选择事件
                input.onchange = (e) => {
                    const files = e.target.files;
                    if(files.length > 0) {
                        resolve(files);
                    }else {
                        reject();
                    }

                    // 移除临时创建的元素
                    document.body.removeChild(input);
                };

                // 添加到页面并触发点击
                document.body.appendChild(input);
                input.click();
            });
        };

        // 使用https://file.mhuitui.com/加载图片，目前用于工程原图
        Vue.prototype.$engineerURL = function(url, defaultUrl = null, timeStr = false) {
            if(url) {
                if(!formReg.url(url)) {
                    let fileName = url.slice(url.lastIndexOf('/') + 1);
                    url = url.slice(0, url.lastIndexOf('/') + 1);
                    fileName = encodeURIComponent(fileName);
                    if(timeStr) {
                        fileName = fileName + "?t=" + Number(new Date());
                    }
                    return baseURL.VUE_APP_API_FILE + url + fileName;
                }else {
                    return url;
                }
            }else {
                return defaultUrl;
            }
        };

        Vue.prototype.$formatURL = function(url, defaultUrl = null, timeStr = false) {
            if(url) {
                if(!formReg.url(url)) {
                    let fileName = url.slice(url.lastIndexOf('/') + 1);
                    url = url.slice(0, url.lastIndexOf('/') + 1);
                    fileName = encodeURIComponent(fileName);
                    if(timeStr) {
                        fileName = fileName + "?t=" + Number(new Date());
                    }
                    return baseURL.VUE_APP_API_YUN + url + fileName;
                }else {
                    return url;
                }
            }else {
                return defaultUrl;
            }
        };
        Vue.prototype.$formatZyzURL = function(url, defaultImg = '') {
            if(url) {
                if(!formReg.url(url)) {
                    return baseURL.VUE_APP_API_OSS + url;
                }else {
                    return url;
                }
            }else {
                return defaultImg;
            }
        };
        Vue.prototype.$headerImgUrl = function(url) {
            if(url) {
                return this.$formatURL(url);
            }else {
                return '/static/img/header-img.jpg';
            }
        };
        /**
         * 开始结束时间组件比较共用方法
         * @param {String} isStart 是开始时间还是结束时间 'start'；'end'
         * @param {Date} nowTime 输入框绑定的时间 如果是【开始时间】 传 【结束时间v-model】，如果是【结束时间】 传 【开始时间v-model】
         * @param {Boolean} isEqual 开始时间和结束时间是否相等 默认是false
         */
        Vue.prototype.$dateCompare = function(isStart, nowTime, isEqual = false) {
            const endDate = "2038-01-01";
            if(nowTime) {
                const temp = nowTime.split(" ");
                if(temp.length > 0) {
                    nowTime = temp[0];
                }
            }
            if(isStart == 'start') {
                return {
                    disabledDate: time => {
                        const endDateVal = nowTime;
                        if(endDateVal) {
                            if(isEqual) {
                                return time.getTime() >= new Date(endDateVal).getTime();
                            }else {
                                return time.getTime() > new Date(endDateVal).getTime() - (1 * 24 * 60 * 60 * 1000);
                            }
                        }else {
                            return time.getTime() >= new Date(endDate).getTime();
                        }
                    }
                };
            }else {
                return {
                    disabledDate: time => {
                        const beginDateVal = nowTime;
                        if(beginDateVal) {
                            if(isEqual) {
                                return (time.getTime() <= new Date(beginDateVal).getTime() - (1 * 24 * 60 * 60 * 1000)) || time.getTime() >= new Date(endDate).getTime();
                            }else {
                                return time.getTime() < new Date(beginDateVal).getTime() || time.getTime() >= new Date(endDate).getTime();
                            }
                        }else {
                            return time.getTime() >= new Date(endDate).getTime();
                        }
                    }
                };
            }
        };

        /**
         * 时间范围限制
         * @param {String} beginTime 开始时间
         * @param {String} endTime 结束时间
         * @param {Boolean} isEqual 开始时间和结束时间是否相等 默认是false
         */
        Vue.prototype.$dateRangeSel = function(beginTime, endTime, isEqual = false) {
            if(beginTime && endTime) {
                const temp = beginTime.split(" ");
                const temp2 = endTime.split(" ");
                if(temp.length > 0) {
                    beginTime = temp[0];
                    endTime = temp2[0];
                }
            }
            return {
                disabledDate: time => {
                    if(isEqual) {
                        if(beginTime && endTime) {
                            return (new Date(beginTime).getTime() - (1 * 24 * 60 * 60 * 1000) > time.getTime()) || (new Date(endTime).getTime() < time.getTime());
                        }else if(beginTime) {
                            return new Date(beginTime).getTime() - (1 * 24 * 60 * 60 * 1000) > time.getTime();
                        }else if(endTime) {
                            return new Date(endTime).getTime() < time.getTime();
                        }
                    }else {
                        if(beginTime && endTime) {
                            return (new Date(beginTime).getTime() > time.getTime()) || (new Date(endTime).getTime() - (1 * 24 * 60 * 60 * 1000) < time.getTime());
                        }else if(beginTime) {
                            return new Date(beginTime).getTime() > time.getTime();
                        }else if(endTime) {
                            return new Date(endTime).getTime() - (1 * 24 * 60 * 60 * 1000) < time.getTime();
                        }
                    }
                }
            };
        };

        // 中文排序公用方法
        Vue.prototype.$sortByZh = function(key, a, b) {
            if(a[key] && b[key]) {
                return a[key].localeCompare(b[key], "zh");
            }else if(!a[key] && !b[key]) {
                return 0;
            }else {
                if(a[key]) {
                    return -1;
                }else {
                    return 1;
                }
            }
        };

        // 公用企业微信发送提示方式
        Vue.prototype.$shortMsgTip = function(data, action = "", duration = 5000) {
            let html = `<div>${action}操作成功！</div>`;
            if(data && data.length > 0) {
                data.forEach((item, index) => {
                    if(item.status == 1) {
                        html += `<div class="${index == 0 ? 'margin-top-sm' : ''}">${item.name}企业微信发送成功！</div>`;
                    }else {
                        if(item.msg) {
                            html += `<div class="${index == 0 ? 'margin-top-sm' : ''}">${item.name}企业微信<span class="text-red">发送失败！</span><span style='font-size: 12px;color: #999;'>${item.msg}</span></div>`;
                        }else {
                            html += `<div class="${index == 0 ? 'margin-top-sm' : ''}">${item.name}企业微信<span class="text-red">发送失败！</span></div>`;
                        }
                    }
                });
            }
            this.$notify({
                dangerouslyUseHTMLString: true,
                message: html,
                duration: duration
            });
        };
    }
};
